function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsMaintenance = function SvgSettingsMaintenance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.58,30.46,30,25.88a2.89,2.89,0,0,0-3.33-.54L22.5,21.18V18.75L17.5,15,15,17.5l3.75,5h2.43l4.16,4.16A2.92,2.92,0,0,0,25.88,30l4.58,4.57a1.45,1.45,0,0,0,2.06,0l2.06-2.06a1.46,1.46,0,0,0,0-2ZM28,23.79A4.11,4.11,0,0,1,30.88,25l.76.76a5.51,5.51,0,0,0,1.71-1.16,5.61,5.61,0,0,0,1.48-5.34.46.46,0,0,0-.78-.21L31.14,22l-2.65-.45-.44-2.65L31,16a.47.47,0,0,0-.22-.79,5.59,5.59,0,0,0-5.33,1.48,5.49,5.49,0,0,0-1.61,4L27,23.9a4.58,4.58,0,0,1,1-.11ZM23.9,27l-2.21-2.21-6,5.95a2.5,2.5,0,0,0,3.54,3.54l4.83-4.83A4.18,4.18,0,0,1,23.9,27Zm-6.4,6.45a1,1,0,0,1-.94-.94.94.94,0,1,1,.94.94Z",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsMaintenance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-maintenance.1535bdf6.svg";
export { ForwardRef as ReactComponent };